import { Column } from "../../../Components/Tables/Table";
import { header } from "../../../Shared/Cards/Card.type";
import { AccountBasicInfoLookUp } from "./accountForm.model";

// Interface for CompanyAddress
export interface CompanyAddress {
  contact_name: string;
  time_zone_name: string;
  address_line_1: string;
  address_line_2: string;
  city: string;
  state_province: string;
  postal_code: string;
  country: any;
}

export const defaultCompanyAddress: CompanyAddress = {
  contact_name: "",
  time_zone_name: "",
  address_line_1: "",
  address_line_2: "",
  city: "",
  state_province: "",
  postal_code: "",
  country: "",
};

// Interface for AccountType
export interface AccountType {
  id: number;
  type: string;
  code: string;
  description: string;
}

export const defaultAccountType: AccountType = {
  id: 0,
  type: "",
  code: "",
  description: "",
};

// Interface for BasicInfo
export interface BasicInfo {
  source: any;
  code: string;
  name: string;
  type: any;
  subscription_amount: string;
  subscription_users: string;
  subscription_clients: string;
  subscription_warehouses: string;
  is_active: boolean;
  environment_type: any;
}

export const defaultBasicInfo: BasicInfo = {
  source: "",
  code: "",
  name: "",
  type: "",
  subscription_amount: "",
  subscription_users: "",
  subscription_clients: "",
  subscription_warehouses: "",
  is_active: false,
  environment_type: "",
};

// Interface for CompanyAccountConfiguration
export interface CompanyAccountConfiguration {
  uom_system: any;
  links?: CompanyAccConfigUrl[];
  attachments?: Attachments[];
  logo?: LogoAttachments;
}

export const defaultCompanyAccountConfiguration: CompanyAccountConfiguration = {
  uom_system: "",
  links: [],
  attachments: [],
  logo: {
    original_name: "",
    content: "",
  },
};

export class attachments {
  public original_name: string;
  public description: string;
  public content: string;
  constructor() {
    this.original_name = "";
    this.content = "";
    this.description = "";
  }
}

// Interface for CompanyAccConfigUrl
export interface CompanyAccConfigUrl {
  id?: number;
  url: string;
  description: string;
}

export const defaultCompanyAccConfigUrl: CompanyAccConfigUrl = {
  id: 0,
  url: "",
  description: "",
};

// Interface for Attachments
export interface Attachments {
  original_name: string;
  description: string;
  content: string;
}

export const defaultAttachments: Attachments = {
  original_name: "",
  content: "",
  description: "",
};

// Interface for LogoAttachments
export interface LogoAttachments {
  original_name: string;
  content: string;
  url?: string;
}

export const defaultLogoAttachments: LogoAttachments = {
  original_name: "",
  content: "",
  url: "",
};

// AccountlistProps interface
export interface AccountlistProps {
  pageName: string;
  columns: Column[];
  addUrl: string;
  listUrl: string;
  gridUrl: string;
  viewtype: string;
  headers: header[];
  getDetails: any;
  search_columns: any;
  db_columns: any[];
  handleToggleChange?: (item: any, status: any) => void;
  update_status_url?: string;
  statusData: any;
  onDataChange?: (data: any) => void;
  setStatusData?: React.Dispatch<React.SetStateAction<null>>;
  data: any;
  refreshTrigger?: number;
  handelEditAction(data: any): void;
  getAccountDetails: any;
  listEndpoint: string;
}

// AccountBasicInfoProps interface
export interface AccountBasicInfoProps {
  handleNext: () => void;
  basicInfo?: BasicInfo;
  setBasicInfo?: (data: BasicInfo) => void;
  basicInfoLookUpData?: AccountBasicInfoLookUp;
}

export interface LogoFile extends File {
  url?: string;
  content?: string;
}

export interface ExistingLogo {
  name?: string;
  url?: string;
  content?: string;
  type?: string;
}
export type LogoType = LogoFile | ExistingLogo;

export interface UrlInput {
  urlLink: string;
  urlName: string;
}